import React from "react"

import styles from "./eventTime.module.scss"

const EventTime = ({ enroll, start }) => {
  return (
    <div className={styles.eventTime}>
      <div>
        <p>
          报名时间
          <small>Registration Dates</small>
        </p>
        <h3>{enroll}</h3>
      </div>
      <div>
        <p>
          比赛时间 <small>Competition Dates</small>
        </p>
        <h3>{start}</h3>
      </div>
    </div>
  )
}

export default EventTime
